module.exports = __webpack_public_path__ + "img/money.7fb7f150.png";